export class Planning {
    public id: number;
    public moduleId: number;
    public name: string;
    public isPlanned: boolean;
    public infos: any;
    public usageDate: string;
}
